/**
 * Format the given duration in seconds to be hh:mm:ss or mm::ss
 */
export function formatDuration(duration: number) {
  if (!duration) return "00:00";

  const roundedDuration = Math.ceil(duration);

  // Now check if it less than one hour then return mm:ss
  if (roundedDuration < 3600) {
    const minutes = Math.floor(roundedDuration / 60);
    const seconds = roundedDuration % 60;
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  }

  // If it is more than one hour then return hh:mm:ss
  const hours = Math.floor(roundedDuration / 3600);
  const minutes = Math.floor((roundedDuration % 3600) / 60);
  const seconds = roundedDuration % 60;

  return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds
    .toString()
    .padStart(2, "0")}`;
}

// Helper for formatting numbers (e.g., 1k)
// We need to floor the value to the nearest 1000
export function formatNumber(num: number) {
  if (!num) return 0;

  if (num >= 1_000_000) return Math.floor(num / 1_000_000) + "M";
  if (num >= 1_000) return Math.floor(num / 1_000) + "K";
  return num.toString();
}
